import React from 'react'
import { Item, Container, Button, Popup } from 'semantic-ui-react'
import { useRouter } from 'next/router'

import SEO from 'lib/components/SEO'
import Loading from 'lib/components/Loading'
import Recall from 'lib/components/Recall'
import useFirebase from 'lib/hooks/useFirebase'
import useUser from 'lib/hooks/useUser'
import useFirestoreLoadMore from 'lib/hooks/useFirestoreLoadMore'

import CategorySelector from './CategorySelector'

const Recalls = ({}) => {
  const router = useRouter()
  const { category } = router.query

  if (category && !['1', '2', '3', '4'].includes(category)) {
    router.push('/recalls')
    return null
  }

  const firebase = useFirebase()

  const queryFn = React.useCallback(() => {
    let q = firebase
      .firestore()
      .collection('recalls')
      .orderBy('date_published', 'desc')
      .limit(15)

    if (category) {
      q = q.where('category', 'array-contains', category)
    }

    return q
  }, [category])

  const [[recalls, loading, error], more] = useFirestoreLoadMore(queryFn)
  const [user, userLoading, userErr] = useUser()

  if (error) {
    console.log('er', error)
    return null
  }

  return (
    <>
      <SEO
        title="Browse recent Canadian recalls: foods, products, vehicles and medical | Recall Monitor"
        description="Browse recent Canadian recalls categorized by foods, consumer products, vehicles, medical equipment and drugs. Get more information and know what to do in the case of a recall."
        canonical="https://recallmonitor.ca/recalls"
      />
      <CategorySelector />
      <Container
        css={{
          marginBottom: '1rem',
        }}
      >
        {!!recalls && !!recalls.length && (
          <Item.Group divided relaxed>
            {recalls.map(recall => (
              <Recall data={recall.data()} key={recall.data().recallId} />
            ))}
          </Item.Group>
        )}
        {loading && <Loading />}
        {!loading && (
          <>
            <div style={{ display: 'flex' }}>
              <Popup
                trigger={
                  <Button
                    onClick={() => {
                      if (!!user.auth) more()
                    }}
                    icon="refresh"
                    labelPosition="right"
                    content="Load More"
                    style={{ margin: '0 auto' }}
                  />
                }
                content="Subscribe to get access to historical data of over 30,000 recalls."
                disabled={!!user.auth}
              />
            </div>
          </>
        )}
      </Container>
    </>
  )
}

export default Recalls
